import { Outlet } from "react-router-dom";
import { HOME_LAYOUT_ID } from "../../constants/appConstants";
import Header from "../Header";
import Footer from "../Footer/Footer";
import styles from "./HomeLayout.module.scss";

const HomeLayout = () => {
  return (
    <div id={HOME_LAYOUT_ID} className={styles.pageWrapper}>
      <div className={styles.headerContainer}>
        <Header />
      </div>
      <div className={styles.outletContainer}>
        <Outlet />
      </div>
      <div className={styles.footerContainer}>
        <Footer />
      </div>
    </div>
  );
};

export default HomeLayout;
